const WhatIsNewContent = () => {
  return (
    <div data-testid="whatisnew-content" className="demo-modal-wrapper">
      {/* <div className="subtitle">Schooljaar 2026-2027</div> */}
      <div className="section">
        <div className="section-description">
          <h3>Activiteiten dupliceren</h3>
          <p>
            Vanaf nu kan je in LLinkid activiteiten dupliceren. Dat is handig wanneer je dezelfde
            activiteit op een later moment opnieuw wil gebruiken.
          </p>
          <ol>
            <li>klik op de pijl van de activiteit;</li>
            <li>
              kies rechts bovenaan voor <strong>Activiteit dupliceren</strong>;
            </li>
            <li>bepaal voor welke klas de kopie geldt;</li>
            <li>geef aan wanneer de activiteit van start moet gaan.</li>
          </ol>
          <p>
            Zo kan je bijvoorbeeld een pijl voor klas A aanmaken en die later dupliceren voor klas
            B.
          </p>
          <h3>Pijlen splitsen per klas</h3>
          <p>
            Wanneer je een vorderingsplan voor meerdere klassen hebt gemaakt, kan je de pijlen
            voortaan ook per klas bekijken. Gebruik daarvoor de schakelaar{' '}
            <strong>Pijlen splitsen</strong>.
          </p>
          <ul>
            <li>standaard staat de schakelaar uit en zie je vooral één grijze pijl;</li>
            <li>
              wanneer je de schakelaar activeert, verschijnen de pijlen afzonderlijk per klas;
            </li>
            <li>
              de verschillende pijlen krijgen een kleur, zodat je sneller ziet welke pijl bij welke
              klas hoort.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WhatIsNewContent;
